(ns shared.core.components.a
  (:require [shared.core.components.interactive :refer [interactive]]
            [shared.core.style :as style]
            [shared.core.components.theme :as theme]))

(defn a [{:keys [href style on-click target disabled? dark-theme-style] :as args} & contents]
  (into [theme/theme
         interactive :a (merge {:style (cond-> {:color (style/color :green :base)
                                                :font-size 14
                                                :text-decoration :underline
                                                :cursor :pointer}
                                               style (merge style)
                                               disabled? (merge {:cursor :not-allowed
                                                                 :opacity 0.8}))
                                :theme (style/dark-style (merge {:color (style/dark-color :primary :base)}
                                                                dark-theme-style))
                                :target target
                                :hover-style (when-not disabled? {:opacity 0.8})
                                :on-click (when-not disabled? on-click)
                                :href (when-not disabled? href)}
                               (select-keys args [:download :title :name]))]
        contents))

(defn red-a [{:keys [style dark-theme-style] :as args} & contents]
  (into [a (assoc args :style (merge {:color (style/color :red :base)} style)
                       :dark-theme-style (merge {:color (style/dark-color :secondary :base)} dark-theme-style))]
        contents))

(defn white-a [{:keys [style] :as args} & contents]
  (into [a (assoc args :style (merge {:color (style/color :white :base)} style))]
        contents))

(defn primary-a [{:keys [style] :as args} & contents]
  (into [a (assoc args :style (merge {:color (style/color :primary :base)} style))]
        contents))
